/* eslint-disable no-underscore-dangle */
import styled from 'styled-components'
import {down} from 'styled-breakpoints'
import {Container} from 'reactstrap'

import {colors} from '~/constants/style'
import {withOuterWrapper, withInnerWrapper} from '~/hocs'

const AdvancedSearchCustomContainer = styled(Container)`
  ${(props) => props.theme.oneColumnLayout && `
    margin-left: -15px;
    margin-right: -15px;
    width: unset;
  `}
`

const AdvancedSearchWrapper = styled(
  withInnerWrapper(AdvancedSearchCustomContainer)('div'),
)`
  background: ${colors.darkBg};
  padding-top: 20px;
  padding-bottom: 20px;

  ${(props) => props.theme.noBg && `
    background: unset;
  `}
`

// OCL = one column layout

const advancedSearchOCL = `
  display: block;
`

const AdvancedSearch = styled(
  withOuterWrapper(AdvancedSearchWrapper)('div'),
)`
  display: flex;

  ${down('sm')} {
    ${advancedSearchOCL}
  }

  ${(props) => props.theme.oneColumnLayout && `
    ${advancedSearchOCL}
  `}
`

const fieldSpacing = 20

AdvancedSearch.FieldsWrapper = styled.div`
  margin-bottom: -${fieldSpacing}px;
  display: flex;
  flex-wrap: wrap;

  input {
    border-radius: 5px;
    border: 1px solid ${colors.bootstrapGray};
  }
`

const advancedSearchLeftOCL = `
  margin-right: 0;
  margin-bottom: ${fieldSpacing}px;
`

AdvancedSearch.Left = styled(
  withInnerWrapper(AdvancedSearch.FieldsWrapper)('div'),
)`
  margin-right: ${fieldSpacing}px;
  flex: 1;

  ${down('sm')} {
    ${advancedSearchLeftOCL}
  }

  ${(props) => props.theme.oneColumnLayout && `
    ${advancedSearchLeftOCL}
  `}
`

const _3timesOfFieldSpacing = fieldSpacing * 3

const advancedSearchFieldWrapperOCL = `
  flex-basis: 100%;
  margin-right: 0;
`

AdvancedSearch.FieldWrapper = styled.div`
  flex: calc((100% - ${_3timesOfFieldSpacing}px) / 4) 0 0;
  margin-right: ${fieldSpacing}px;
  height: 42px;

  &:nth-child(4n) {
    margin-right: 0;
  }

  margin-bottom: ${fieldSpacing}px;

  > select  {
    height: 100%;
    border-radius: 5px;
    border: none;
    border: 1px solid ${colors.bootstrapGray};
  }

  ${down('sm')} {
    ${advancedSearchFieldWrapperOCL}
  }

  ${(props) => props.theme.oneColumnLayout && `
    ${advancedSearchFieldWrapperOCL}
  `}
`

const _4timesOfFieldSpacing = fieldSpacing * 4

const advancedSearchRightOCL = `
  width: 100%;
  height: 42px;
  font-size: 1.5rem;
`

AdvancedSearch.Right = styled.button.attrs({type: 'submit'})`
  flex: calc((100% - ${_4timesOfFieldSpacing}px) / 5) 0 0;
  background: ${colors.green};
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2rem;
  border-radius: 5px;

  ${down('sm')} {
    ${advancedSearchRightOCL}
  }

  ${(props) => props.theme.oneColumnLayout && `
    ${advancedSearchRightOCL}
  `}
`

export default AdvancedSearch
